import { BaseQuery, QueryConfig, QueryResponse, QueryResult } from "@/shared/types/base";
import { Vendedor } from "@/shared/types/vendedor"; 
import { removeNullOrEmptyKeys, sleep } from "@/shared/utils";
import { api } from "@/api";
import { useQuery } from "@tanstack/react-query";
import { ReactNode } from "react";

export interface VendedoresQuery extends BaseQuery {
    nombre?: string,
    numDocumento?: string,
    telefono?: string,
    direccion?: string,
    email?: string,
}

export async function getAllVendedores(query?: VendedoresQuery): Promise<QueryResponse<Vendedor>> {
    await sleep(1000);
    const response = await api.get("vendedores", { params: removeNullOrEmptyKeys(query) });
    return response.data;
}

export function useGetAllVendedoresQuery(query: VendedoresQuery = {}, queryConfig: QueryConfig<QueryResponse<Vendedor>> = {}) {
    return useQuery({
        ...queryConfig,
        queryFn: async () => await getAllVendedores(query),
        queryKey: ["vendedores", query],
    })
}

export interface GetAllVendedorQueryProps{
    query:VendedoresQuery,
    queryConfig?: QueryConfig<QueryResponse<Vendedor>>,
    children:(queryResult:QueryResult<QueryResponse<Vendedor>>)=>ReactNode
}

export function GetAllVendedoresQuery({
    query,
    queryConfig,
    children
}:GetAllVendedorQueryProps){
    const queryResult = useGetAllVendedoresQuery(query, queryConfig);
    return children&&children(queryResult);
}